<template>
  <div>
    <!-- 1. list of comps -->
    <v-tabs v-if="lAction === 'view' || showResolve" v-model="tab"
    flat color="primary" dark
    grow height="40"
    fixed-tabs
    >
    <v-tab v-for="(tabitem, n) in tabitems" :key="n" :href="`#tab-${n}`">
      <v-badge overlap>
        <template v-slot:badge v-if="enabledFilter['tab-' + n]">
          <v-icon class="caption">filter_list</v-icon>
        </template>
        <div class="pa-2">{{ tabitem + ' ('+ stats[tabitem] +')' }}</div>
      </v-badge>
    </v-tab>
  </v-tabs>

  <v-container class="pa-1" grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs-items v-if="lAction === 'view' || showResolve" v-model="tab">
          <!-- personal and community comps -->

          <v-tab-item v-for="(tabitem, n) in tabitems" :key="n" :value="`tab-${n}`">
            <v-card flat>
              <v-card-text v-if="comps[tabitem].length === 0 && !load" class="info--text text-xs-center">No complaints!</v-card-text>
              <v-expansion-panel :value="selRec">
                <v-expansion-panel-content
                v-for="(comp, i) in comps[tabitem]" :key="i" @input="loadComments(comp), loadDetail(comp), loadCompAttachment(comp)">
                <div slot="header">
                  <v-layout row class="pb-4">
                    <v-flex xs12 class="caption white--text">
                      <div class="pa-1 grey lighten-4 caption black--text" style="position:absolute; top:5px; left:0px">
                        {{ comp.comp_cat + ' (Complaint #' + comp.comp_id + ')'}}
                        <v-icon v-if="comp.is_comm_comp">location_city</v-icon> <v-icon v-else>person</v-icon>
                      </div>
                      <div v-if="comp.comp_status === 'New' || comp.comp_status === 'Reopened'" class="pa-1 red lighten-2" style="position:absolute; top:5px; right:0px">
                        {{ comp.comp_status }}
                      </div>
                      <div v-else-if="comp.comp_status === 'Assigned'" class="pa-1 blue lighten-2" style="position:absolute; top:5px; right:0px">
                        {{ comp.comp_status }}
                      </div>
                      <div v-else-if="comp.comp_status === 'In Progress'" class="pa-1 yellow black--text" style="position:absolute; top:5px; right:0px">
                        {{ comp.comp_status }}
                      </div>
                      <div v-else-if="comp.comp_status.includes('Resolved')" class="pa-1 success" style="position:absolute; top:5px; right:0px">
                        {{ comp.comp_status }}
                      </div>
                      <div v-else class="pa-1 accent white--text" style="position:absolute; top:5px; right:0px">
                        {{ comp.comp_status }}
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs3 sm2 md1>
                      <v-avatar size="48px" slot="activator" class="pt-4">
                        <img :src="config.STATIC_FILES_DIR + comp.avatar_url"/>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs9 sm9 md11 :class="$vuetify.breakpoint.sm?'ml-2':''">
                      <div class="subheading">{{ comp.comp_title }}
                        <span v-if="comp.tagged_by === curUserId" style="position:absolute; top:35px; right:25px"><v-icon color="yellow">star_border</v-icon></span>
                      </div>
                      <div>
                        <span class="primary--text"> {{ comp.cust_name + ' (' + (comp.is_behalf ? (comp.role_name + (comp.block_nm ? (' on behalf of ' + comp.block_nm + ',' + comp.unit_no) : '')) : (comp.block_nm + ',' + comp.unit_no)) + ')' }} </span>
                        <span class="grey--text"> {{ ' - ' + comp.comp_text.substring(0,35) + '...' }} </span>
                      </div>
                      <div class="caption grey--text mt-2">
                        <span class="mr-2">{{ handy.formatDateTime(comp.comp_dt) }}</span>
                      </div>
                      <div class="caption info--text">
                        <v-tooltip top :disabled="comp.agreed===0">
                          <template v-slot:activator="{ on }">
                            <span @mouseover="loadListOfPeopleAgreed(comp)" v-on="on" class="mr-2">{{ comp.agreed }} Agreed</span>
                          </template>
                          <span v-for="(agreed, i) in totalAgreed" class="caption">{{ agreed.cust_name + ' '+ '(' + (agreed.block_nm ? (agreed.block_nm + ',' + agreed.unit_no) : agreed.role_name) +') ' }}<br/>
                          </span>
                        </v-tooltip>
                        <v-tooltip top :disabled="comp.comments===0">
                          <template v-slot:activator="{ on }">
                            <span @mouseover="loadListOfPeopleCommentedComp(comp)" v-on="on" class="mr-2">{{ comp.comments }} Comments</span>
                          </template>
                          <span v-for="(comment, i) in totalComment" class="caption">{{ comment.cust_name + ' '+ '(' + (comment.block_nm ? (comment.block_nm + ',' + comment.unit_no) : comment.role_name) +') ' }}<br/>
                          </span>
                        </v-tooltip>
                        <v-tooltip top :disabled="comp.tags===0">
                          <template v-slot:activator="{ on }">
                            <span @mouseover="loadListOfPeoplePinnedComp(comp)" v-on="on" >{{ comp.tags }} Pinned</span>
                          </template>
                          <span v-for="(pinned, i) in totalPinned" class="caption">{{ pinned.cust_name + ' '+ '(' + (pinned.block_nm ? (pinned.block_nm + ',' + pinned.unit_no) : pinned.role_name) +') ' }}<br/>
                          </span>
                        </v-tooltip>
                      </div>
                      <div v-if="comp.comp_status.includes('Resolved')" @click="loadCompRatings(comp)">
                        <v-rating size="20" color="accent" background-color="grey"
                        dense v-model="comp.overall" :readonly="!(comp.user_can_rate && comp.user_can_rate.split(',').map(rec => parseInt(rec)).indexOf(config.USER_ID) > -1)" @input="saveRatings(comp, true)"></v-rating>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
                <v-card flat :id="'comp_' + n + '_' + i">
                  <v-card-text class="pa-2">
                    <div class="pb-1">{{comp.comp_text}}</div>
                    <!--Complaint Attachments -->
                    <v-card flat>
                      <v-card-text class="pt-0 pr-0 pl-0 pb-2" v-if="comp.files && comp.files.filter(rec => rec.is_selected).length > 0">
                        <div v-viewer="options" class="clearfix">
                          <template v-for="(file, index) in comp.files.filter(rec => rec.source_type === 'Complaint')">
                            <img width="80px" :src="config.FM_SPACES_BASE_URL + file.file_url" :data-source="config.FM_SPACES_BASE_URL + file.file_url" :key="index" class="ma-1" style="display: inline-block; cursor: pointer;">
                          </template>
                        </div>
                      </v-card-text>
                    </v-card>
                    <!-- comments -->
                    <v-card flat v-for="(comment, c) in comp.comments_list" :key="c" :class="(comment.comment_id ? 'grey ' : '') + 'lighten-4 mb-1'" :style="!comment.comment_id ? 'border: 1px solid lightgray' : ''">
                      <v-card-text class="pt-2 pr-2 pb-0 pl-2">
                        <v-layout row>
                          <v-flex class="pl-2 pb-2" xs2 sm1>
                            <v-avatar size="36px" slot="activator">
                              <img :src="config.STATIC_FILES_DIR + comment.avatar_url"/>
                            </v-avatar>
                          </v-flex>
                          <v-flex class="pl-2" xs12 sm12>
                            <div v-if="comment.comment_status === 'Recalled' || comment.comment_status === 'Disabled'">
                              <span class="primary--text"> {{ comment.cust_name }} </span>
                              <span v-if="comment.comment_status === 'Recalled'" class="warning--text caption"> - Recalled comment</span>
                              <span v-else class="warning--text caption"> - Disabled by MC</span>
                            </div>
                            <div v-else>
                              <span :class="comment.comment_id ? 'primary--text' : 'grey--text'"> {{ comment.comment_id ? 'Commented by' : comment.comment_status + ' by' }} {{ comment.cust_name }} {{ comment.comment_status === 'Assigned' && comment.assigned_to ? ' to ' + comment.assigned_to : '' }} </span>
                              <span class="caption grey--text" style="float:right">{{ handy.formatDateTime(comment.comment_dt) + (comment.edited_dt?'.':'') }}
                                <span v-if="comment.edited_dt" class="black--text">Edited.</span>
                                <span v-if="comment.comment_id" style="float:right" class="mr-2 caption info--text">&nbsp;&nbsp;{{ comment.agreed }} Agreed</span>
                              </span>
                              <div> {{ comment.comment_text }} </div>
                              <v-card class="blue lighten-4 mt-2 mb-2" v-if="comment.comment_status === 'Out Of Scope' && comp.comp_status === 'Out Of Scope'">
                                <v-card-text class="pb-0">
                                  Sorry to inform you that the problem stated in complaint is out of scope of maintenance contract made with the association. If you wish, you can avail our on-call service at nominal rate or you can get it done by any other vendor of your choice.
                                </v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn small @click="loadRateCard(), showRateCard = true">Rate card</v-btn>
                                  <v-btn small @click="bookOnCallService(comp)">Book on-call service</v-btn>
                                </v-card-actions>
                              </v-card>
                              <v-card class="mt-2 mb-2" v-if="comment.comment_status === 'On-call Service Booked' && comp.comp_status === 'On-call Service Booked'">
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn small @click="loadRateCard(), showRateCard = true">Rate card</v-btn>
                                  <v-btn small @click="bookOnCallService(comp)">Cancel on-call booking</v-btn>
                                </v-card-actions>
                              </v-card>
                            </div>
                            <div v-if="comment.ready_for_disable">
                              <span v-if="comment.comment_status !== 'Disabled'" color="grey" style="float:right"><v-btn class="ma-0" icon @click.stop="cancelDisableComment(comment)"><v-icon small>close</v-icon></v-btn></span>
                              <v-text-field hide-details label="Disabled reason" counter="100" v-model="comment.disabled_reason"></v-text-field>
                            </div>
                            <div class="info white--text pa-1" v-if="(comment.user_id === curUserId || config.IS_MC_MEMBER || config.IS_ADMIN) && comment.comment_status === 'Disabled'">
                              <span class="yellow--text">Disabled reason (only visible to you)<br /></span>
                              <span>{{ comment.disabled_reason }}</span>
                            </div>
                          </v-flex>
                        </v-layout>
                        <!--Resolve & Comment Attachments -->
                        <v-layout row wrap>
                          <span v-if="comp.files && comp.files.filter(rec => rec.is_selected).length > 0">
                            <div v-viewer="options" class="clearfix">
                              <template v-for="(file, index) in comp.files.filter(rec => (rec.source_type === 'Comment' && rec.source_ref_id === comment.comment_id) || (rec.source_type === 'Resolve' && rec.source_ref_id === comment.comp_det_id))">
                                <img width="80px" :src="config.FM_SPACES_BASE_URL + file.file_url" :data-source="config.FM_SPACES_BASE_URL + file.file_url" :key="index" class="ma-1" style="display: inline-block; cursor: pointer;">
                              </template>
                            </div>
                          </span>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions v-if="comment.comment_status === 'Active'" class="ma-0 pa-0">
                        <v-spacer></v-spacer>
                        <v-btn v-if="comment.user_id === curUserId" icon @click.native="prepareEditComment(comp, comment)"><v-icon small>edit</v-icon></v-btn>
                        <v-btn icon v-if="comment.user_id === curUserId || config.IS_MC_MEMBER || config.IS_ADMIN" @click.native="recallComment(comment, comp)"><v-icon small :color="comment.ready_for_disable ? 'accent' : ''">delete</v-icon></v-btn>
                        <v-btn v-if="comment.agreed_by != curUserId" icon @click.native="agreeComment(comment, 'agree')"><v-icon small>thumb_up</v-icon></v-btn>
                        <v-btn v-else icon class="primary--text" @click.native="agreeComment(comment, 'disagree')"><v-icon small>thumb_up</v-icon></v-btn>
                      </v-card-actions>
                    </v-card>
                    <div v-if="comp.ready_for_comment">
                      <div>
                        <span color="grey" style="float:right"><v-btn class="ma-0" icon small @click.stop="cancelComment(comp)"><v-icon small>clear</v-icon></v-btn></span>
                        <v-text-field hide-details textarea
                        placeholder="Your comment" rows="2"
                        v-model="comp.comment.comment_text"></v-text-field>
                      </div>
                      <div>
                        <input style="display:none;" type="file" id="commentFileInput"
                        accept="image/*" multiple @change="loadFilesFromFileBrowser(comp.comment)"/>
                        <v-btn icon @click="pickFile"><v-icon>attach_file</v-icon></v-btn>
                        <span v-if="comp.comment.files && comp.comment.files.filter(rec => rec.is_selected && rec.source_type === 'Comment').length > 0">
                          <span v-for="(file, index) in comp.comment.files.filter(rec => rec.source_type === 'Comment' && rec.source_ref_id === comp.comment.comment_id)" :key="index">
                            <v-chip @input="$forceUpdate()" v-model="file.is_selected" close>{{ file.file_name }}</v-chip>
                          </span>
                        </span>
                        <span v-else>Attachment if any<span class="caption"> (images only, upto 20MB)</span></span>
                      </div>
                      <div style="float:right">
                        <v-btn class="ma-0" flat color="accent" @click.stop="postComment(comp)" :disabled="beingSaved">Comment</v-btn>
                      </div>
                    </div>
                  </v-card-text>
                  <div v-if="!comp.ready_for_comment">
                    <v-card-actions v-if="comp.user_id === curUserId" class="pt-0">
                      <v-spacer></v-spacer>
                      <v-btn v-if="comp.comp_status === 'New'" icon @click.native="prepareUpdate(comp)"><v-icon small >edit</v-icon></v-btn>
                      <v-btn v-if="comp.comp_status === 'New'" icon @click.native="deleteComp(comp)" :disabled="beingSaved"><v-icon small >delete</v-icon></v-btn>
                      <v-btn v-if="comp.commented_by != curUserId" icon class="pl-3 pr-3" @click.native="prepareComment(comp)"><v-icon small>comment</v-icon></v-btn>
                      <v-btn v-else icon class="primary--text pl-3 pr-3" @click.native="prepareComment(comp)"><v-icon small>comment</v-icon></v-btn>
                      <v-btn v-if="config.IS_USER_EMPOWERED && !comp.comp_status.includes('Resolved') && comp.comp_status !== 'Rejected' && comp.comp_status !== 'Out Of Scope'" small flat color="accent" @click.native="prepareResolve(comp)">Update / Resolve</v-btn>
                      <v-btn v-if="comp.comp_status.includes('Resolved') || comp.comp_status === 'Rejected' || comp.comp_status === 'Out Of Scope'" small flat @click.native="reopenComp(comp)" :disabled="beingSaved">Reopen</v-btn>
                    </v-card-actions>
                    <v-card-actions v-else-if="tabitem === 'all open'" class="pt-0">
                      <v-spacer></v-spacer>
                      <v-btn v-if="comp.agreed_by != curUserId" icon class="pl-3 pr-3" @click.native="agreeComp(comp, 'agree')"><v-icon small >thumb_up</v-icon></v-btn>
                      <v-btn v-else icon class="primary--text pl-3 pr-3" @click.native="agreeComp(comp, 'disagree')"><v-icon small>thumb_up</v-icon></v-btn>
                      <v-btn v-if="comp.commented_by != curUserId" icon class="pl-3 pr-3" @click.native="prepareComment(comp)"><v-icon small>comment</v-icon></v-btn>
                      <v-btn v-else icon class="primary--text pl-3 pr-3" @click.native="prepareComment(comp)"><v-icon small>comment</v-icon></v-btn>
                      <v-btn v-if="comp.tagged_by != curUserId" class="ma-0 pa-0" flat small @click.native="tagComp(comp, 'tag')">Pin</v-btn>
                      <v-btn v-else small flat class="primary--text ma-0" @click.native="tagComp(comp, 'untag')">Pinned</v-btn>
                      <v-btn v-if="config.IS_USER_EMPOWERED" small flat color="accent" @click.native="prepareResolve(comp)">Update / Resolve</v-btn>
                    </v-card-actions>
                    <v-card-actions v-else-if="tabitem !== 'all closed'" class="pt-0">
                      <v-spacer></v-spacer>
                      <v-btn small flat @click.native="prepareResolve(comp)">Update / Resolve</v-btn>
                    </v-card-actions>
                  </div>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-divider></v-divider>
            <infinite-loading v-if="tabitem === 'mine'" @infinite="loadMoreMine" spinner="spiral">
              <span slot="spinner"></span> <!-- no default spinner -->
              <span slot="no-more"></span>
            </infinite-loading>
            <infinite-loading v-else-if="tabitem === 'all open'" @infinite="loadMoreOpen" spinner="spiral">
              <span slot="spinner"></span> <!-- no default spinner -->
              <span slot="no-more"></span> <!-- no default message -->
            </infinite-loading>
            <infinite-loading v-else @infinite="loadMoreClosed" spinner="spiral">
              <span slot="spinner"></span> <!-- no default spinner -->
              <span slot="no-more"></span> <!-- no default message -->
            </infinite-loading>
          </v-card>
        </v-tab-item>

        <v-btn small
        :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:15px;':'bottom:15px; left:320px;')"
        dark fab fixed
        color="accent"
        @click.native="prepareFilter">
        <v-badge overlap color="info">
          <template v-slot:badge v-if="enabledFilter[this.tab]">
            <v-icon class="caption">done</v-icon>
          </template>
          <v-icon class="pa-2">filter_list</v-icon>
        </v-badge>
      </v-btn>

      <v-btn
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; right:15px;':'bottom:15px; right:15px;')"
      dark fab fixed
      color="accent"
      @click.native="prepareCreate">
      <v-icon>add</v-icon>
    </v-btn>

    <!-- 5. show filter category in bottom sheet -->
    <v-bottom-sheet inset class="caption" v-model="showFilter" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md class="pa-0">
            <v-layout row wrap>
              <v-flex xs12>
                <div class="caption primary--text">Filter by attributes</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="filterList[tab].comp_id"
                label="Complaint No"
                hide-details
                maxlength="11"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                v-model="filterList[tab].comp_cat_list"
                :items="cats"
                label="Category"
                item-text="comp_cat"
                item-value="comp_cat_id"
                hide-details
                small-chips
                clearable
                multiple
                return-object
                @input="filterCompCatList(filterList[tab])"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                v-model="filterList[tab].comp_type_list"
                :items="['Personal', 'Community']"
                label="Type"
                small-chips
                clearable
                dense
                multiple
                hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                v-model="filterList[tab].severity_list"
                label="Severity"
                :items="['Critical', 'Normal', 'Major']"
                small-chips
                clearable
                dense
                multiple
                hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                v-model="filterList[tab].comp_status_list"
                label="Status"
                :items="statusList"
                small-chips
                clearable
                dense
                multiple
                hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <div class="caption primary--text pt-3">Filter by people</div>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                v-model="filterList[tab].created_user_pair_list"
                label="Created by"
                :items="mcList"
                item-text="user_name"
                item-value="user_id"
                hide-details
                small-chips
                clearable
                dense
                multiple
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                v-model="filterList[tab].assigned_user_pair_list"
                :items="mcList"
                label="Assigned to"
                item-text="user_name"
                item-value="user_id"
                hide-details
                small-chips
                clearable
                dense
                multiple
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 v-if="config.USER_HAS_MORE_UNITS || config.IS_USER_EMPOWERED">
                <v-autocomplete
                label="Unit"
                v-model="filterList[tab].unit_id"
                :items="config.USER_HAS_MORE_UNITS ? config.UNITS : unitList"
                item-text="block_and_unit"
                item-value="unit_id"
                :rules="config.IS_OTHER_USER ? [] : [rules.required]"
                dense
                clearable
                multiple
                hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <div class="caption primary--text pt-3">Filter by date</div>
              </v-flex>
              <v-flex xs6>
                <v-dialog ref="dlgFromDate"
                persistent v-model="dlgFromDate"
                lazy max-width="290px"
                :return-value.sync="filterList[tab].from_dt"
                >
                <v-text-field
                slot="activator" label="Logged date from"
                v-model="filterList[tab].from_dt"
                append-icon="event"
                readonly clearable
                hide-details
                ></v-text-field>
                <v-date-picker v-model="filterList[tab].from_dt" scrollable
                first-day-of-week="1"
                >
                <v-spacer></v-spacer>
                <v-btn flat @click="dlgFromDate = false">Cancel</v-btn>
                <v-btn flat color="accent" @click="$refs.dlgFromDate.save(filterList[tab].from_dt)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs6>
            <v-dialog ref="dlgToDate"
            persistent v-model="dlgToDate"
            lazy max-width="290px"
            :return-value.sync="filterList[tab].to_dt"
            >
            <v-text-field
            slot="activator" label="Logged date to"
            v-model="filterList[tab].to_dt"
            append-icon="event"
            readonly clearable
            hide-details
            ></v-text-field>
            <v-date-picker v-model="filterList[tab].to_dt" scrollable
            first-day-of-week="1"
            >
            <v-spacer></v-spacer>
            <v-btn flat @click="dlgToDate = false">Cancel</v-btn>
            <v-btn flat color="accent" @click="$refs.dlgToDate.save(filterList[tab].to_dt)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</v-card-text>
<v-card-actions>
  <v-btn flat @click.stop="showFilter = false">Close</v-btn>
  <v-spacer></v-spacer>
  <v-btn flat @click="clearFilter">Clear all</v-btn>
  <v-btn class="ma-0" flat color="accent" @click="applyFilter">Apply</v-btn>
</v-card-actions>
</v-card>
</v-bottom-sheet>

</v-tabs-items>

<!-- 2. create / edit -->
<v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="lForm" @submit.prevent="saveChanges()">
        <v-card flat>
          <v-flex xs12 sm9 mx-auto>
            <v-card-text class="pt-2">
              <v-container grid-list-md class="pa-0">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-select
                    v-model="lComp.comp_to_list"
                    label="To"
                    :items="tos"
                    item-value="value"
                    item-text="text"
                    :rules="[rules.required]"
                    chips
                    multiple
                    hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex xs8 sm9 class="mt-3 subheading">
                    <span>Is it affecting community?</span>
                  </v-flex>
                  <v-flex xs4 sm3>
                    <v-switch
                    :label="lComp.is_comm_comp ?'Yes':'No'"
                    v-model="lComp.is_comm_comp"
                    hide-details
                    ></v-switch>
                  </v-flex>
                  <v-flex xs8 sm9 class="mt-1 subheading">
                    <span>Is it critical?</span>
                  </v-flex>
                  <v-flex xs4 sm3>
                    <v-switch
                    class="mt-0"
                    :label="lComp.is_critical?'Yes':'No'"
                    v-model="lComp.is_critical"
                    hide-details
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12>
                    <span class="caption grey--text">Be reasonable, pls check this only if it needs to be attended immediately</span>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="config.USER_HAS_MORE_UNITS || config.IS_OTHER_USER">
                    <v-select
                    label="Unit"
                    v-model="lComp.unit_id"
                    :items="config.USER_HAS_MORE_UNITS ? config.UNITS : unitList"
                    item-text="block_and_unit"
                    item-value="unit_id"
                    :rules="config.IS_OTHER_USER && lComp.is_comm_comp ? [] : [rules.required]"
                    :hint="'Choose on behalf of which unit the complaint is raised' + (config.IS_OTHER_USER ? ' or leave it empty for common area complaints' : '')"
                    persistent-hint
                    clearable
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-combobox
                    v-model="lComp.comp_cat_pair"
                    label="Category"
                    :items="cats"
                    item-text="comp_cat"
                    item-value="comp_cat_id"
                    :rules="[rules.required]"
                    hide-details
                    @input="findCat"
                    ></v-combobox>
                  </v-flex>
                  <v-flex xs12 class="mt-2">
                    <v-text-field
                    ref='title' v-model="lComp.comp_title"
                    label="Complaint title"
                    :rules="[rules.required]"
                    hide-details
                    maxlength="100"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                  class="mt-2"
                  v-model="lComp.comp_text"
                  label="Complaint description"
                  :rules="[rules.required]"
                  hide-details
                  rows="4"
                  maxlength="1000"
                  ></v-textarea>
                </v-flex>
                <v-flex xs6>
                  <v-dialog ref="prefAttendDt"
                  persistent v-model="prefAttendDt"
                  lazy max-width="290px"
                  :return-value.sync="lComp.pref_attend_dt"
                  >
                  <v-text-field
                  slot="activator" :label="$vuetify.breakpoint.smAndUp ? 'Pref. date to attend' : 'Pref. date'"
                  v-model="lComp.pref_attend_dt"
                  append-icon="event"
                  readonly clearable
                  hide-details
                  ></v-text-field>
                  <v-date-picker v-model="lComp.pref_attend_dt" scrollable
                  first-day-of-week="1"
                  :min="today"
                  >
                  <v-spacer></v-spacer>
                  <v-btn flat @click="prefAttendDt = false">Cancel</v-btn>
                  <v-btn flat color="accent" @click="$refs.prefAttendDt.save(lComp.pref_attend_dt)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs6>
              <v-dialog
              ref="prefAttendTime"
              persistent
              v-model="prefAttendTime"
              lazy
              max-width="290px"
              :return-value.sync="lComp.pref_attend_time"
              >
              <v-text-field
              slot="activator"
              :label="$vuetify.breakpoint.smAndUp ? 'Pref. time to attend' : 'Pref. time'"
              v-model="lComp.pref_attend_time"
              append-icon="access_time"
              persistent-hint
              clearable
              readonly
              hide-details
              ></v-text-field>
              <v-time-picker v-model="lComp.pref_attend_time"
              >
              <v-spacer></v-spacer>
              <v-btn flat @click="prefAttendTime = false">Cancel</v-btn>
              <v-btn flat color="accent" @click="$refs.prefAttendTime.save(lComp.pref_attend_time)">OK</v-btn>
            </v-time-picker>
          </v-dialog>
        </v-flex>
        <span class="caption grey--text">This is optional. if provided, technicians will try to attend around the preferred time based on the availability</span>
        <v-flex xs12>
          <input style="display:none" type="file" ref="fileInput"
          accept="image/*" multiple @change="loadFilesFromFileBrowser(lComp)"/>
          <v-btn icon @click="pickFile"><v-icon>attach_file</v-icon></v-btn>
          <span v-if="lComp.files && lComp.files.filter(rec => rec.is_selected && rec.source_type === 'Complaint').length > 0">
            <span v-for="(file, index) in lComp.files.filter(rec => rec.source_type === 'Complaint')" :key="index">
              <v-chip v-model="file.is_selected" close>{{ file.file_name }}</v-chip>
            </span>
          </span>
          <span v-else class="caption">Attachment if any (images only, upto 20MB)</span>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card-text>
  <v-card-actions class="pt-0">
    <v-spacer></v-spacer>
    <v-btn @click.stop="cancelChanges">Cancel</v-btn>
    <v-btn type="submit" color="accent" :disabled="beingSaved">Log</v-btn>
  </v-card-actions>
</v-flex>
</v-card>
</v-form>
</v-flex>
</v-layout>
</v-container>

<!-- 3. resolve -->
<v-dialog v-model="showResolve" max-width="500px" persistent>
  <v-form ref="lForm" @submit.prevent="saveChanges()">
    <v-card scrollable>
      <v-card-title class="title pb-0">
        Update/Resolve Complaint
      </v-card-title>
      <v-card-text class="pb-1">
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-center white--text">
              <div class="primary lighten-1 pa-1">
                <strong>{{lComp.cust_name + ' (' + (lComp.is_behalf ? (lComp.role_name + (lComp.block_nm ? (' on behalf of ' + lComp.block_nm + ',' + lComp.unit_no) : '')) : (lComp.block_nm + ',' + lComp.unit_no)) + ')'}}</strong>
              </div>
              <div class="primary lighten-2 pa-1">
                {{ lComp.comp_title }}
              </div>
            </v-flex>
            <v-flex xs6>
              <span class="caption grey--text">Was sent to </span><br />{{ lComp.comp_to_list && lComp.comp_to_list.join() }}
            </v-flex>
            <v-flex xs6>
              <span class="caption grey--text">Preferred date & time </span><br />{{lComp.pref_attend_dt_time_text}}
            </v-flex>
            <v-flex xs6>
              <v-combobox
              v-model="lComp.comp_cat_pair"
              label="Category"
              :items="cats"
              item-text="comp_cat"
              item-value="comp_cat_id"
              :rules="[rules.required]"
              hide-details
              ></v-combobox>
            </v-flex>
            <v-flex xs6>
              <v-select
              v-model="lComp.comp_severity"
              label="Severity"
              :items="['Normal', 'Major', 'Critical']"
              :rules="[rules.required]"
              hide-details
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-alert class="pa-3" color="warning lighten-1" value="true">
                <v-select
                v-model="lComp.comp_status"
                label="Status"
                :items="statusList"
                :rules="[rules.required]"
                hide-details
                ></v-select>
                <v-combobox
                v-model="lComp.assigned_to_pair"
                label="Assigned to"
                :items="mcList"
                item-text="user_name"
                item-value="user_id"
                @input="lComp.comp_status === 'New' ? lComp.comp_status = 'Assigned' : lComp.comp_status"
                ></v-combobox>
                <v-textarea
                outline
                hide-details
                label="Notes/Resolution"
                rows="2"
                v-model="lComp.notes">
              </v-textarea>
            </v-alert>
          </v-flex>
          <v-flex xs12>
            <input style="display:none" type="file" ref="resolveFileInput"
            accept="image/*" multiple @change="loadFilesFromFileBrowser(lComp)"/>
            <v-btn icon @click="pickFile" class="ma-0"><v-icon>attach_file</v-icon></v-btn>
            <span v-if="lComp.files && lComp.files.filter(rec => rec.is_selected && rec.source_type === 'Resolve').length > 0">
              <span v-for="(file, index) in lComp.files.filter(rec => rec.source_type === 'Resolve')" :key="index">
                <v-chip v-model="file.is_selected" close>{{ file.file_name }}</v-chip>
              </span>
            </span>
            <span v-else>Attachment if any<span class="caption"> (images only, upto 20MB)</span></span>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions class="pt-0">
      <v-spacer></v-spacer>
      <v-btn flat @click.stop="cancelChangesResol">Cancel</v-btn>
      <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
    </v-card-actions>
  </v-card>
</v-form>
</v-dialog>

<!-- 4. on-call services rate card -->
<v-dialog v-model="showRateCard" max-width="500px" persistent scrollable>
  <v-card>
    <v-card-title class="title grey lighten-4">
      <span>Rate (On-call Services)</span>
      <v-spacer></v-spacer>
      <v-btn small icon @click.native="showRateCard=false, search = ''"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="rateHead"
      :items="rateCard"
      hide-actions
      :search="search"
      >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.service_name }}</td>
          <td>{{ props.item.uom }}</td>
          <td>{{ handy.formatCur(props.item.price) }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
  <v-card-actions class="grey lighten-4 caption">
    <v-layout row wrap>
      <v-flex xs6>
        <v-text-field
        append-icon="search"
        hide-details
        v-model="search"
        class="pa-0 ml-1"
        placeholder="Search"
        clearable
        ></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-download-as
        title="Rate Card (On-call Services)"
        :headers="rateHead"
        :items="rateCard"
        ></v-download-as>
      </v-flex>
    </v-layout>
  </v-card-actions>
</v-card>
</v-dialog>

<!-- 6. User feedback form -->
<v-dialog v-model="showRating" scrollable persistent max-width="450px">
  <v-card>
    <v-card-title class="title grey lighten-4 py-0 pr-0">
      Feedback
      <v-spacer></v-spacer>
      <v-btn icon @click="cancelRating"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs7 md6>
              <div>Overall satisfaction</div>
            </v-flex>
            <v-flex xs5 md6 class="text-xs-right">
              <v-rating size="20" color="accent" background-color="grey"
              :readonly="!rComp.is_related_user" dense
              v-model="rComp.overall" @input="saveRatings(rComp, false)"></v-rating>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-divider class="my-2"></v-divider>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs7 md6>
              <div>Quality of work</div>
            </v-flex>
            <v-flex xs5 md6 class="text-xs-right">
              <v-rating size="20" color="accent" background-color="grey"
              :readonly="!rComp.is_related_user" dense
              v-model="rComp.quality" @input="saveRatings(rComp, false)"></v-rating>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs7 md6>
              <div>Technician had proper tools</div>
            </v-flex>
            <v-flex xs5 md6 class="text-xs-right">
              <v-rating size="20" color="accent" background-color="grey"
              :readonly="!rComp.is_related_user" dense
              v-model="rComp.tools" @input="saveRatings(rComp, false)"></v-rating>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs7 md6>
              <div>Friendliness of technician</div>
            </v-flex>
            <v-flex xs5 md6 class="text-xs-right">
              <v-rating size="20" color="accent" background-color="grey"
              :readonly="!rComp.is_related_user" dense
              v-model="rComp.friendliness" @input="saveRatings(rComp, false)"></v-rating>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-divider class="my-2"></v-divider>
        <v-flex xs12>
          <v-textarea
          label="Any other feedback (optional)"
          v-model="rComp.other_feedback"
          hide-actions
          rows="2"
          maxlength="100"
          :disabled="!rComp.is_related_user"
          @change="saveRatings(rComp, false)"
          ></v-textarea>
        </v-flex>
      </v-flex>
    </v-card-text>
  </v-card>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

<div v-if="load" class="text-xs-center mt-5">
  <v-progress-circular indeterminate color="primary"></v-progress-circular>
</div>

</v-flex>
</v-layout>
</v-container>
</div>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import InfiniteLoading from 'vue-infinite-loading'
import VDownloadAs from './VDownloadAs.vue'

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
Vue.use(Viewer)

export default {
  props: ['action'],
  components:
  {
    InfiniteLoading,
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      // common
      load: false,
      lAction: '',
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      recPerPage: 10,
      lastRec: [],
      selRec: 0,
      selId: 0,
      selTab: 0,
      selStatus: 'mine',
      handy: handy,
      config: config,
      rules: handy.rules,
      customToolbar: handy.customToolbar,
      beingSaved: false,
      prefAttendDt: false,
      prefAttendTime: false,
      // component specific
      tab: 'tab-0',
      tabitems: ['mine', 'all open', 'all closed'],
      comps: {},
      stats: {},
      lComp: '',
      beforeChangeHash: '',
      curUserId: config.USER_ID,
      cats: [],
      tos: [],
      mcList: [],
      isFMPresent: false,
      isFMEnabled: false,
      isHDPresent: false,
      isHDEnabled: false,
      prevStatus: '',
      unitList: [],
      // comments
      showComment: false,
      showResolve: false,
      comments: [],
      lComment: '',
      // filters
      showFilter: false,
      enabledFilter: [],
      filterList: [],
      dlgFromDate: false,
      dlgToDate: false,
      severities: ['Critical', 'Major', 'Normal'],
      statusList: ['New', 'Reopened', 'Assigned', 'On-hold', 'In Progress', 'Resolved', 'Rejected', 'Out Of Scope', 'On-call Service Booked', 'Resolved [On-call Service]'],
      showRateCard: false,
      rateCard: [],
      search: '',
      rateHead: [
        { text: 'Category', value: 'service_name' },
        { text: 'Service', value: 'uom' },
        { text: 'Rate', value: 'price' }
      ],
      options: {
        toolbar: true,
        url: 'data-source'
      },
      // overall ratings
      showRating: false,
      rComp: {},
      totalAgreed: [],
      totalComment: [],
      totalPinned: []
    }
  },
  created () {
    // initialize required list while creation
    for (var i = 0; i < this.tabitems.length; i++) {
      this.lastRec[this.tabitems[i]] = false
      this.comps[this.tabitems[i]] = []
      this.stats[this.tabitems[i]] = 0
      this.enabledFilter['tab-' + i] = false
      this.filterList['tab-' + i] = this.getEmptyFilter()
    }
    if (config.IS_OTHER_USER) {
      this.loadUnits()
    }
  },
  mounted () {
    // load available categories and send to options
    this.loadPrereq()
    .then(res => {
      // load values
      if (this.action !== 'create') {
        this.loadStats()
        // load comp & show the one if chosen at dashboard
        if (this.action) {
          this.selTab = Number(this.action.substring(0, 1))
          this.tab = 'tab-' + this.selTab
          this.selId = Number(this.action.substring(2))
          this.selStatus = this.tab === 'tab-0' ? 'mine' : this.tab === 'tab-1' ? 'all open' : 'all closed'
        }
        for (var i = 0; i < this.tabitems.length; i++) {
          this.loadComps(this.tabitems[i])
        }
        this.loading()
        this.lAction = 'view'
      } else {
        this.prepareCreate()
      }
    })
  },
  computed: {
    today: function () {
      return handy.formatDBDate(Date())
    }
  },
  methods: {
    loading () {
      var root = this
      this.load = true
      setTimeout(function () {
        root.load = false
      }, 1000)
    },
    msg (m, isError = false) {
      this.sbarCol = isError ? 'error' : 'success'
      this.sbar = true
      this.sbarMsg = m
    },
    getEmptyComp () {
      var emptyComp = {
        comm_id: config.COMM_ID,
        user_id: config.USER_ID,
        unit_id: config.UNIT_ID_LIST.length ? config.UNIT_ID_LIST[0] : '',
        cust_id: config.CUST_ID, // for notification
        avatar_url: config.AVATAR_URL,
        comp_to_list: (this.isHDPresent && this.isHDEnabled) ? ['Helpdesk Executive'] : ((this.isFMPresent && this.isFMEnabled) ? ['FM'] : ['Mgmt Committee']),
        comp_cat_pair: '',
        comp_type: 'Personal',
        is_comm_comp: false,
        comp_severity: 'Normal',
        is_critical: false,
        comp_title: '',
        comp_text: '',
        comp_status: 'New',
        agreed: '0',
        comments: '0',
        tags: '0',
        comment: {},
        comments_list: [],
        details: [],
        files: [],
        is_behalf: config.IS_OTHER_USER
      }
      return emptyComp
    },
    prepareCreate () {
      this.lComp = this.getEmptyComp()
      this.lAction = 'create'
      // all units if a staff wishes to raise a complaint
      if (config.IS_OTHER_USER) {
        this.loadUnits()
      }
    },
    prepareUpdate (curComp) {
      var path = require('path')
      this.lComp = Object.assign({}, curComp) // keep the original object safely before changes
      this.lComp.comp_to_list = curComp.comp_to.split(',')
      this.lComp.pref_attend_dt = this.lComp.pref_attend_dt ? handy.formatDBDate(this.lComp.pref_attend_dt) : null
      this.lComp.comp_cat_pair = {comp_cat: this.lComp.comp_cat, comp_cat_id: this.lComp.comp_cat_id}
      if (curComp.fileUrls.length > 0) {
        this.lComp.files = []
        curComp.fileUrls.forEach((rec) => {
          this.lComp.files.push({
            file_url: config.FM_SPACES_BASE_URL + rec.file_url,
            file_name: rec.file_url ? path.basename(rec.file_url) : '',
            is_selected: true,
            source_type: rec.source_type
          })
        })
      } else {
        this.lComp.files = []
        curComp.files.forEach((rec) => {
          this.lComp.files.push({
            file_url: config.FM_SPACES_BASE_URL + rec.file_url,
            file_name: rec.file_url ? path.basename(rec.file_url) : '',
            is_selected: true,
            source_type: rec.source_type
          })
        })
      }
      // all units if a staff wishes update a complaint that he raised on behalf of some unit
      if (config.IS_OTHER_USER) {
        this.loadUnits()
      }

      this.lAction = 'update'
      this.beforeChangeHash = this.lComp.files.filter(rec => rec.is_selected).length + this.lComp.comp_to_list + this.lComp.unit_id + this.lComp.comp_cat_pair.comp_cat_id + this.lComp.is_comm_comp + this.lComp.is_critical + this.lComp.comp_title + this.lComp.comp_text + this.lComp.pref_attend_dt + this.lComp.pref_attend_time + this.lComp.comp_status + (this.lComp.assigned_to_pair && this.lComp.assigned_to_pair.user_id) + this.lComp.notes
    },
    prepareResolve (curComp) {
      var path = require('path')
      this.prevStatus = curComp.comp_status
      this.lComp = Object.assign({}, curComp) // keep the original object safely before changes
      this.lComp.comp_to_list = curComp.comp_to.split(',')
      this.lComp.pref_attend_dt_time_text = curComp.pref_attend_dt ? (handy.formatDate(curComp.pref_attend_dt) + ' ' + handy.formatTime(curComp.pref_attend_time)) : 'NA'
      this.lComp.comp_cat_pair = {comp_cat: this.lComp.comp_cat, comp_cat_id: this.lComp.comp_cat_id}
      // show recent resolution
      if (this.lComp.details && this.lComp.details.length) {
        var lastDet = this.lComp.details[this.lComp.details.length - 1]
        if (lastDet.assigned_user_id) {
          this.lComp.assigned_to_pair = {user_id: lastDet.assigned_user_id, user_name: lastDet.assigned_to}
        } else if (lastDet.assigned_staff_id) {
          this.lComp.assigned_to_pair = {user_id: lastDet.assigned_staff_id, user_name: lastDet.assigned_to}
        } else if (lastDet.assigned_us_emp_id) {
          this.lComp.assigned_to_pair = {user_id: lastDet.assigned_us_emp_id, user_name: lastDet.assigned_to}
        }
        this.lComp.notes = ''
      }
      this.lComp.files = []
      curComp.fileUrls.forEach((rec) => {
        this.lComp.files.push({
          file_url: rec.file_url,
          file_name: rec.file_url ? path.basename(rec.file_url) : '',
          is_selected: true,
          source_type: rec.source_type
        })
      })
      this.beforeChangeHash = this.lComp.files.length + this.lComp.comp_to_list + this.lComp.comp_cat_pair.comp_cat_id + this.lComp.comp_type + this.lComp.comp_severity + this.lComp.comp_title + this.lComp.comp_text + this.lComp.comp_status + (this.lComp.assigned_to_pair && this.lComp.assigned_to_pair.user_id) + this.lComp.notes
      this.showResolve = true
      this.lAction = 'resolve'
    },
    findCat () {
      if (this.lComp.comp_cat_pair) {
        this.lComp.comp_cat_id = this.lComp.comp_cat_pair.comp_cat_id
        this.lComp.comp_cat = this.lComp.comp_cat_pair.comp_cat
      }
    },
    saveChanges () {
      // check for change
      if (this.lAction !== 'create') {
        var afterChangeHash = ''
        if (this.lAction === 'resolve') {
          afterChangeHash = this.lComp.files.length + this.lComp.comp_to_list + this.lComp.comp_cat_pair.comp_cat_id + this.lComp.comp_type + this.lComp.comp_severity + this.lComp.comp_title + this.lComp.comp_text + this.lComp.comp_status + (this.lComp.assigned_to_pair && this.lComp.assigned_to_pair.user_id) + this.lComp.notes
        } else {
          afterChangeHash = this.lComp.files.length + this.lComp.comp_to_list + this.lComp.unit_id + this.lComp.comp_cat_pair.comp_cat_id + this.lComp.is_comm_comp + this.lComp.is_critical + this.lComp.comp_title + this.lComp.comp_text + this.lComp.pref_attend_dt + this.lComp.pref_attend_time + this.lComp.comp_status + (this.lComp.assigned_to_pair && this.lComp.assigned_to_pair.user_id) + this.lComp.notes
        }
        if (this.beforeChangeHash === afterChangeHash) {
          this.msg('No changes made to save', true)
          return
        }
      }
      // other validation
      if (this.lAction === 'resolve') {
        if ((this.lComp.comp_status.includes('Resolved') || this.lComp.comp_status === 'Rejected' || this.lComp.comp_status === 'On-hold') && !this.lComp.notes) {
          var str = 'Please provide resolution description'
          if (this.lComp.comp_status === 'Rejected') {
            str = 'Please provide reason for rejection'
          } else if (this.lComp.comp_status === 'On-hold') {
            str = 'Please provide reason for on-hold'
          }
          this.msg(str, true)
          return
        }
      } else {
        if (!this.$refs.lForm.validate()) {
          return
        } else if (!this.lComp.unit_id) {
          if (!config.IS_OTHER_USER) {
            this.msg('Choose an unit', true)
            return
          } else {
            this.lComp.unit_id = null
          }
        } else if (!this.lComp.comp_cat_id) {
          this.msg('Invalid complaint category', true)
          return
        } else if (!this.lComp.comp_to_list.length) {
          this.msg('Complaint has to be addressed to atleast one person', true)
          return
        } else if ((this.lComp.pref_attend_dt && !this.lComp.pref_attend_time) || (!this.lComp.pref_attend_dt && this.lComp.pref_attend_time)) {
          this.msg('Both preferred date and time need to be chosen', true)
          return
        } else if ((this.lComp.pref_attend_dt + ' ' + this.lComp.pref_attend_time) <= handy.formatDBDateTime(Date())) {
          this.msg('Not a valid preferred time, choose sometime in future', true)
          return
        }

        // other pre processing
        this.lComp.comp_type = this.lComp.is_comm_comp ? 'Community' : 'Personal'
        this.lComp.comp_severity = this.lComp.is_critical ? 'Critical' : this.lComp.comp_severity
        this.lComp.comp_to = this.lComp.comp_to_list.join()
      }

      this.lComp.attach_dir = 'img/' + this.lComp.comm_id + '/comp/'

      this.lComp.is_other_user = config.IS_OTHER_USER
      if (config.IS_OTHER_USER) { // notification purpose
        this.lComp.cust_name = config.CUST_NAME
        this.lComp.role_name = config.ROLE_NAME
      }

      if (this.lAction === 'create') {
        this.createComp()
      } else if (this.lAction === 'update') {
        this.updateComp()
      } else if (this.lAction === 'resolve') {
        this.resolveComp()
      }
    },
    createComp () {
      // validate and save Changes
      if (this.$refs.lForm.validate()) {
        this.beingSaved = true
        this.axios.post(config.API_URL + '/comp/create', this.lComp)
        .then(response => {
          this.lComp.comp_id = response.data
          if (this.lComp.files.length > 0) {
            this.axios.post(config.API_URL + '/compAttachment/create', this.lComp)
            .then(response => {
              // refresh stats
              this.loadStats()
              // refresh comp list in front end
              this.loadComps('mine', true)
              this.loadComps('all open', true)
              this.loadCompAttachment(this.lComp)

              this.lAction = 'view'
              this.beingSaved = false
              this.tab = 'tab-0'
              this.loading()
            })
          } else {
            // refresh stats
            this.loadStats()
            // refresh comp list in front end
            this.loadComps('mine', true)
            this.loadComps('all open', true)
            this.loadCompAttachment(this.lComp)

            this.lAction = 'view'
            this.beingSaved = false
            this.tab = 'tab-0'
            this.loading()
          }
        })
        .catch(err => {
          this.msg(err.response.data, true)
          this.beingSaved = false
        })
      }
    },
    updateComp () {
      // update into db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/comp/update', this.lComp)
      .then(response => {
        if (this.lComp.files.filter(rec => rec.is_selected).length >= 0) {
          this.axios.post(config.API_URL + '/compAttachment/update', this.lComp)
          .then(response => {
            // update front end
            // refresh stats
            this.loadStats()
            this.loadCompAttachment(this.lComp)
            // comp
            var idx = this.comps['mine'].findIndex(comp => comp.comp_id === this.lComp.comp_id)
            Object.assign(this.comps['mine'][idx], this.lComp)

            idx = this.comps['all open'].findIndex(comp => comp.comp_id === this.lComp.comp_id)
            Object.assign(this.comps['all open'][idx], this.lComp)

            this.lAction = 'view'
            this.beingSaved = false
            this.loading()
          })
        } else {
          // update front end
          // refresh stats
          this.loadStats()
          this.loadCompAttachment(this.lComp)
          // comp
          var idx = this.comps['mine'].findIndex(comp => comp.comp_id === this.lComp.comp_id)
          Object.assign(this.comps['mine'][idx], this.lComp)

          idx = this.comps['all open'].findIndex(comp => comp.comp_id === this.lComp.comp_id)
          Object.assign(this.comps['all open'][idx], this.lComp)

          this.lAction = 'view'
          this.beingSaved = false
          this.loading()
        }
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    resolveComp () {
      if (this.prevStatus === this.lComp.comp_status) {
        if (!confirm('No change in status, still want to save?')) {
          return
        }
      }
      // update into db
      // pre processing
      this.lComp.changed_by = config.USER_ID
      if (this.lComp.assigned_to_pair) {
        if (this.lComp.assigned_to_pair.user_id) {
          if (this.lComp.assigned_to_pair.user_name.includes('US Staff:')) {
            this.lComp.assigned_staff_id = null
            this.lComp.assigned_user_id = null
            this.lComp.assigned_us_emp_id = this.lComp.assigned_to_pair.user_id
          } else if (this.lComp.assigned_to_pair.user_name.includes('Staff:')) {
            this.lComp.assigned_staff_id = this.lComp.assigned_to_pair.user_id
            this.lComp.assigned_user_id = null
            this.lComp.assigned_us_emp_id = null
          } else { // MC or fm
            this.lComp.assigned_user_id = this.lComp.assigned_to_pair.user_id
            this.lComp.assigned_staff_id = null
            this.lComp.assigned_us_emp_id = null
          }
          this.lComp.assigned_to = this.lComp.assigned_to_pair.user_name
        } else {
          this.lComp.assigned_to = this.lComp.assigned_to_pair
          this.lComp.assigned_user_id = null
        }
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/comp/resolve', this.lComp)
      .then(response => {
        this.lComp.comp_det_id = response.data
        // refresh front end
        if (this.lComp.user_id === config.USER_ID) {
          var idx = this.comps['mine'].findIndex(comp => comp.comp_id === this.lComp.comp_id)
          Object.assign(this.comps['mine'][idx], this.lComp)
        } else {
          this.comps['mine'].splice(idx, 1)
        }
        // update open and closed accordingly
        idx = this.comps['all open'].findIndex(comp => comp.comp_id === this.lComp.comp_id)
        if (this.lComp.comp_status.includes('Resolved') || this.lComp.comp_status === 'Rejected' || this.lComp.comp_status === 'Out Of Scope') {
          this.comps['all open'].splice(idx, 1)
          this.comps['all closed'].splice(0, 0, this.lComp) // insert at top
        } else {
          Object.assign(this.comps['all open'][idx], this.lComp)
        }
        if (this.lComp.files.filter(rec => rec.is_selected).length >= 0) {
          this.axios.post(config.API_URL + '/compAttachment/resolve', this.lComp)
          .then(response => {
            this.loadComments(this.lComp) // reload comments
            this.loadDetail(this.lComp) // reload details
            this.loadCompAttachment(this.lComp) // reload attachments
            // refresh stats
            this.loadStats()
            this.$forceUpdate()
          })
        }
        this.showResolve = false
        this.lAction = 'view'
        this.beingSaved = false
        this.loading()
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    deleteComp (curComp) {
      if (!confirm('Sure, you want to delete the complaint "' + curComp.comp_title + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/comp/delete', curComp)
      .then(response => {
        // refresh comp list in front end
        var idx = this.comps['mine'].findIndex(comp => comp.comp_id === curComp.comp_id)
        this.comps['mine'].splice(idx, 1)
        idx = this.comps['all open'].findIndex(comp => comp.comp_id === curComp.comp_id)
        this.comps['all open'].splice(idx, 1)
        // refresh stats
        this.loadStats()
        this.beingSaved = false
        this.$forceUpdate()
        this.loading()
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    reopenComp (curComp) {
      if (!confirm('Sure, you want to reopen the complaint "' + curComp.comp_title + '"?')) {
        return
      }
      // up in db
      curComp.changed_by = config.USER_ID
      this.beingSaved = true
      this.axios.post(config.API_URL + '/comp/reopen', curComp)
      .then(response => {
        curComp.comp_status = 'Reopened'
        this.loadComments(curComp)
        this.loadDetail(curComp)
        // other tabs
        this.comps['all open'].splice(0, 0, curComp) // insert at top
        var idx = this.comps['all closed'].findIndex(comp => comp.comp_id === curComp.comp_id)
        this.comps['all closed'].splice(idx, 1)
        // refresh mine tab if the reopened complaint belongs to the same user
        if (curComp.user_id === config.USER_ID) {
          var cidx = this.comps['mine'].findIndex(comp => comp.comp_id === curComp.comp_id)
          Object.assign(this.comps['mine'][cidx], curComp)
        }
        // refresh stats
        this.loadStats()
        this.beingSaved = false
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    agreeComp (curComp, curAction) {
      if (curAction === 'agree') {
        curComp.agreed_by = config.USER_ID
      }
      this.axios.post(config.API_URL + '/comp/' + curAction, curComp)
      .then(response => {
        // refresh the front end
        if (curAction === 'agree') {
          curComp.agreed++
        } else {
          curComp.agreed_by = ''
          curComp.agreed--
        }
        this.$forceUpdate() // update dom
        // refresh in other tabs
        var tmpTab = this.tab === 'tab-0' ? 'all open' : 'mine'
        this.comps[tmpTab].find((comp) => {
          if (comp.comp_id === curComp.comp_id) {
            comp.agreed_by = curComp.agreed_by
            comp.agreed = curComp.agreed
            return true
          }
        })
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    tagComp (curComp, curAction) {
      if (curAction === 'tag') {
        curComp.tagged_by = config.USER_ID
      }
      this.axios.post(config.API_URL + '/comp/' + curAction, curComp)
      .then(response => {
        // refresh the front end
        if (curAction === 'tag') {
          curComp.tags++
          this.comps['mine'].splice(0, 0, curComp) // insert at top
        } else {
          curComp.tagged_by = ''
          curComp.tags--
          var idx = this.comps['mine'].findIndex(comp => comp.comp_id === curComp.comp_id)
          this.comps['mine'].splice(idx, 1)
        }
        this.$forceUpdate() // update dom
        // refresh in other tab
        var tmpTab = this.tab === 'tab-0' ? 'all open' : 'mine'
        this.comps[tmpTab].find((comp) => {
          if (comp.comp_id === curComp.comp_id) {
            comp.tagged_by = curComp.tagged_by
            comp.tags = curComp.tags
            return true
          }
        })
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    cancelChanges () {
      if (this.action) { // in case come from different parent page, go there
        this.$router.go(-1)
      } else {
        this.lAction = 'view'
      }
      this.beingSaved = false
    },
    cancelChangesResol () {
      this.showResolve = false
      this.lAction = 'view'
      this.beingSaved = false
    },
    prepareComment (curComp) {
      curComp.ready_for_comment = true
      curComp.comment = {
        comp_id: curComp.comp_id,
        user_id: config.USER_ID,
        comm_id: config.COMM_ID, // for notification
        cust_id: config.CUST_ID, // for notification
        comp_title: curComp.comp_title, // for notification
        comp_to: curComp.comp_to, // for notification
        comp_type: curComp.comp_type, // for notification
        avatar_url: config.AVATAR_URL,
        comp_status: curComp.comp_status,
        comment_text: '',
        comment_dt: new Date(),
        edited_dt: '',
        comment_status: 'Active',
        agreed: '0',
        files: []
      }
      this.$forceUpdate()
    },
    cancelComment (curComp) {
      curComp.ready_for_comment = false
      this.beingSaved = false
      this.$forceUpdate()
    },
    cancelDisableComment (curComment) {
      curComment.ready_for_disable = false
      this.$forceUpdate()
    },
    loadPrereq () {
      return new Promise((resolve, reject) => {
        var qry = {
          params: {
            comm_id: config.COMM_ID,
            comm_id_list: [config.COMM_ID],
            vendor_id: config.IS_BB_VENDOR ? config.FM_VENDOR_ID : ''
          }
        }
        // available categories
        this.axios.get(config.API_URL + '/getComplaintCotegories/', qry)
        .then(response => {
          this.cats = response.data
        })

        // is help desk available for community
        this.axios.get(config.API_URL + '/isHelpDeskAvailableForCommunity/', qry)
        .then(response => {
          if (response.data[0].total) {
            this.isHDPresent = true
          } else {
            this.isHDPresent = false
          }
          // is fm available for community
          this.axios.get(config.API_URL + '/isFMAvailableForCommunity/', qry)
          .then(response => {
            if (response.data[0].total) {
              this.isFMPresent = true
            } else {
              this.isFMPresent = false
            }
            var lCompAdr = ''
            this.axios.get(config.API_URL + '/getCompSetByCommId/', qry)
            .then(response => {
              lCompAdr = response.data[0]
              this.isHDEnabled = lCompAdr.is_hd_enabled
              this.isFMEnabled = lCompAdr.is_fm_enabled
              if (this.isHDPresent && lCompAdr.is_hd_enabled) {
                this.tos.push({text: 'Helpdesk Executive', value: 'Helpdesk Executive'})
              }
              if (this.isFMPresent && lCompAdr.is_fm_enabled) {
                if (config.COMM_COUNTRY_CODE === 'MY') {
                  this.tos.push({text: 'Facility Manager', value: 'FM'})
                } else {
                  this.tos.push({text: 'Facility Manager', value: 'FM'})
                }
              }
              if (lCompAdr.is_mc_enabled) {
                if (config.COMM_COUNTRY_CODE === 'MY') {
                  this.tos.push({text: 'JMB/Mgmt Committee', value: 'Mgmt Committee'})
                } else {
                  this.tos.push({text: 'Mgmt Committee', value: 'Mgmt Committee'})
                }
              }
              resolve(true) // resolving here it self as it is must prerequisite while mounted
            })
          })
        })

        // available mc members + fm + staff
        this.mcList = []
        this.axios.get(config.API_URL + '/getEligibleAssigneeForComplaints/', qry)
        .then(response => {
          var tmpList = response.data.filter(rec => !rec.is_sv_user) // to do: shall be able to assign to user in backoffice
          tmpList.forEach(rec => {
            this.mcList.push({user_id: rec.user_id, user_name: rec.cust_name})
          })
        })
      })
    },
    loadUnits () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID
        }
      }
      this.axios.get(config.API_URL + '/getUnitsByCommId/', qry)
      .then(response => {
        this.unitList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.unitList = []
      })
    },
    loadStats () {
      for (var i = 0; i < this.tabitems.length; i++) {
        this.loadIndStats(this.tabitems[i])
      }
    },
    loadIndStats (status) {
      // load number of complaints
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID,
          comp_status: status,
          is_user_empowered: config.IS_USER_EMPOWERED,
          filter: this.filterList[this.tab]
        }
      }
      this.axios.get(config.API_URL + '/getTotalComplaintsByStatus/', qry)
      .then(response => {
        this.stats[status] = response.data[0].tot
        this.$forceUpdate()
      })
    },
    loadComps (status, fresh = false) {
      if (fresh) {
        this.comps[status] = []
      }
      var qry = {
        params: {
          user_id: config.USER_ID,
          comp_status: status,
          cust_id: config.CUST_ID,
          comm_id: config.COMM_ID,
          last_comp_id: (fresh || this.comps[status].length === 0) ? '' : this.comps[status][this.comps[status].length - 1].comp_id,
          rec_per_page: this.recPerPage,
          is_user_empowered: config.IS_USER_EMPOWERED,
          filter: this.filterList[this.tab]
        }
      }
      this.axios.get(config.API_URL + '/getComplaintsByStatus/', qry)
      .then(response => {
        if (response.data.length === 0) {
          this.lastRec[status] = true
        } else {
          if (this.comps[status].length === 0) {
            this.comps[status] = response.data
            this.$forceUpdate()
            // load comments & detail of first one / chosen one from dashboard by default
            if (this.action && this.selStatus === status) {
              this.selRec = this.comps[status].findIndex(rec => rec.comp_id === this.selId)
              this.loadComments(this.comps[status][this.selRec])
              this.loadDetail(this.comps[status][this.selRec])

              // focus the chosen one
              setTimeout(() => {
                var tmpComp = document.getElementById('comp_' + this.selTab + '_' + this.selRec)
                tmpComp.scrollIntoView({block: 'center', inline: 'nearest'})
              }, 500)
            } else {
              this.loadComments(this.comps[status][0])
              this.loadDetail(this.comps[status][0])
            }
          } else {
            this.comps[status] = this.comps[status].concat(response.data)
          }
          if (response.data.length < this.recPerPage) { // got only fewer than per page count
            this.lastRec[status] = true
          } else {
            this.lastRec[status] = false
          }
        }
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadComments (curComp) {
      var qry = {
        params: {
          user_id: curComp.user_id,
          comp_id: curComp.comp_id
        }
      }
      this.axios.get(config.API_URL + '/getComplaintDetail/', qry)
      .then(response => {
        curComp.comments_list = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, true)
        curComp.comments_list = []
      })
    },
    loadDetail (curComp) {
      var qry = {
        params: {
          comp_id: curComp.comp_id
        }
      }
      this.axios.get(config.API_URL + '/loadCompCommentDetails/', qry)
      .then(response => {
        curComp.details = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, true)
        curComp.details = []
      })
    },
    postComment (curComp) {
      if (curComp.comment.comment_text.trim().length === 0) {
        this.msg('Comment is empty', true)
      } else {
        // save the changes in db
        curComp.comment.is_other_user = config.IS_OTHER_USER
        curComp.comment.unit_id = curComp.unit_id
        if (config.IS_OTHER_USER) { // for notification purpose
          curComp.comment.cust_name = config.CUST_NAME
          curComp.comment.role_name = config.ROLE_NAME
        }
        this.beingSaved = true
        this.axios.post(config.API_URL + '/comp/comment', curComp.comment)
        .then(response => {
          // refresh comment list
          var idx = -1
          var cidx = -1
          var tmpTab = ''
          if (!curComp.comment.comment_id) { // fresh comment
            curComp.comment.comment_id = response.data
            curComp.comment.cust_name = config.CUST_NAME
            curComp.commented_by = config.USER_ID
            curComp.comments++
            curComp.comments_list.push(curComp.comment)

            // refresh in other tabs
            tmpTab = this.tab === 'tab-0' ? 'all open' : 'mine'
            idx = this.comps[tmpTab].findIndex(comp => comp.comp_id === curComp.comp_id)
            if (idx >= 0) {
              this.comps[tmpTab][idx].commented_by = config.USER_ID
              this.comps[tmpTab][idx].comments++
              if (this.comps[tmpTab][idx].comments_list) {
                this.comps[tmpTab][idx].comments_list.push(curComp.comment)
              }
            }
          } else { // comment edited
            cidx = curComp.comments_list.findIndex(com => com.comment_id === curComp.comment.comment_id)
            curComp.comment.edited_dt = new Date()
            Object.assign(curComp.comments_list[cidx], curComp.comment)

            // refresh in other tabs
            tmpTab = this.tab === 'tab-0' ? 'all open' : 'mine'
            idx = this.comps[tmpTab].findIndex(comp => comp.comp_id === curComp.comp_id)
            if (idx >= 0) {
              if (this.comps[tmpTab][idx].comments_list) {
                cidx = this.comps[tmpTab][idx].comments_list.findIndex(com => com.comment_id === curComp.comment.comment_id)
                curComp.comment.edited_dt = new Date()
                Object.assign(this.comps[tmpTab][idx].comments_list[cidx], curComp.comment)
              }
            }
          }
          if (curComp.comment.files.length > 0) {
            this.axios.post(config.API_URL + '/compAttachment/comment', curComp.comment)
            .then(response => {
              this.loadCompAttachment(curComp)
              this.loadComments(curComp)
              this.$forceUpdate()
            })
            .catch(err => {
              this.msg(err.response.data, true)
              this.beingSaved = false
            })
          } else {
            this.loadComments(curComp)
          }
          curComp.ready_for_comment = false
          curComp.comment = null
          this.beingSaved = false
          this.$forceUpdate()
        })
        .catch(err => {
          this.msg(err.response.data, true)
          this.beingSaved = false
        })
      }
    },
    prepareEditComment (curComp, curComm) {
      var path = require('path')
      curComp.ready_for_comment = true
      curComp.comment = Object.assign({}, curComm) // keep the original object safely before changes
      curComp.comment.files = []
      curComp.files.forEach((rec) => {
        curComp.comment.files.push({
          file_url: config.FM_SPACES_BASE_URL + rec.file_url,
          file_name: path.basename(rec.file_url),
          is_selected: true,
          is_changed: false,
          source_type: rec.source_type,
          source_ref_id: rec.source_ref_id
        })
      })
      this.$forceUpdate()
    },
    agreeComment (curComment, curAction) {
      if (curAction === 'agree') {
        curComment.agreed_by = config.USER_ID
      }

      this.axios.post(config.API_URL + '/comp/comment-' + curAction, curComment)
      .then(response => {
        // refresh the front end
        if (curAction === 'agree') {
          curComment.agreed++
        } else {
          curComment.agreed_by = ''
          curComment.agreed--
        }
        // refresh in other tabs
        var tmpTab = this.tab === 'tab-0' ? 'all open' : 'mine'
        var idx = this.comps[tmpTab].findIndex(comp => comp.comp_id === curComment.comp_id)
        if (idx >= 0) {
          if (this.comps[tmpTab][idx].comments_list) {
            var cidx = this.comps[tmpTab][idx].comments_list.findIndex(com => com.comment_id === curComment.comment_id)
            Object.assign(this.comps[tmpTab][idx].comments_list[cidx], curComment)
          }
        }
        this.$forceUpdate() // update dom
      })
      .catch(err => {
        this.msg(err.response.data, true)
        curComment.agreed_by = ''
      })
    },
    recallComment (curComment, curComp) {
      if (curComment.user_id === config.USER_ID) {
        if (!confirm('Sure, you want to recall the comment?')) {
          return
        }
      } else { // mc or admin wish to disable it seems
        if (curComment.ready_for_disable) {
          if (!curComment.disabled_reason) {
            this.msg('Enter the disabled reason', true)
            return
          }
        } else {
          curComment.ready_for_disable = true
          this.$forceUpdate()
          return
        }
        curComment.disabled_by = config.USER_ID
      }
      this.axios.post(config.API_URL + '/comp/comment-recall', curComment)
      .then(response => {
        if (curComment.user_id === config.USER_ID) {
          curComment.comment_status = 'Recalled'
          curComp.files = []
        } else {
          curComment.comment_status = 'Disabled'
          curComment.ready_for_disable = false
          curComp.files = []
        }
        // refresh in other tabs
        var tmpTab = this.tab === 'tab-0' ? 'all open' : 'mine'
        var idx = this.comps[tmpTab].findIndex(comp => comp.comp_id === curComment.comp_id)
        if (idx >= 0) {
          if (this.comps[tmpTab][idx].comments_list) {
            var cidx = this.comps[tmpTab][idx].comments_list.findIndex(com => com.comment_id === curComment.comment_id)
            Object.assign(this.comps[tmpTab][idx].comments_list[cidx], curComment)
          }
        }
        this.loadCompAttachment(curComment)
        this.loadComments(curComment)
        this.$forceUpdate() // update dom
      })
      .catch(err => {
        this.msg(err.response.data, true)
        curComment.disabled_by = ''
        curComment.disabled_reason = ''
      })
    },
    loadMoreMine ($state) {
      // load more into current tab
      this.load = true
      setTimeout(() => {
        this.loadComps('mine')
        setTimeout(() => {
          $state.loaded()
          if (this.lastRec['mine']) {
            $state.complete()
          }
          this.$forceUpdate()
          this.load = false
        }, 100)
      }, 500)
    },
    loadMoreOpen ($state) {
      this.load = true
      // load more into current tab
      setTimeout(() => {
        this.loadComps('all open')
        setTimeout(() => {
          $state.loaded()
          if (this.lastRec['all open']) {
            $state.complete()
          }
          this.$forceUpdate()
          this.load = false
        }, 100)
      }, 500)
    },
    loadMoreClosed ($state) {
      // load more into current tab
      this.load = true
      setTimeout(() => {
        this.loadComps('all closed')
        setTimeout(() => {
          $state.loaded()
          if (this.lastRec['all closed']) {
            $state.complete()
          }
          this.$forceUpdate()
          this.load = false
        }, 100)
      }, 500)
    },
    prepareFilter () {
      this.showFilter = true
    },
    cancelFilters () {
      this.showFilter = false
    },
    pickFile () {
      if (this.lAction === 'create' || this.lAction === 'update') {
        this.$refs.fileInput.click()
      } else if (this.lAction === 'resolve') {
        this.$refs.resolveFileInput.click()
      } else {
        document.getElementById('commentFileInput').click()
      }
    },
    loadFilesFromFileBrowser (curComp) {
      const files = event.target.files
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
            curComp.files.push({
              file_url: e.target.result.split(',')[1],
              file_name: file.name,
              is_selected: true,
              is_changed: true,
              source_type: (this.lAction === 'create' || this.lAction === 'update') ? 'Complaint' : (this.lAction === 'resolve') ? 'Resolve' : 'Comment'
            })
            this.$forceUpdate()
          }
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
    },
    loadCompAttachment (curComp) {
      var path = require('path')
      var qry = {
        params: {
          comp_id: curComp.comp_id
        }
      }
      curComp.fileUrls = []
      curComp.files = []
      this.axios.get(config.API_URL + '/getAttachmentByCompId/', qry)
      .then(response => {
        curComp.fileUrls = response.data
        curComp.fileUrls.forEach((rec) => {
          curComp.files.push({
            file_url: rec.file_url,
            file_name: path.basename(rec.file_url),
            is_selected: true,
            is_changed: false,
            source_type: rec.source_type,
            source_ref_id: rec.source_ref_id
          })
        })
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, true)
        curComp.fileUrls = []
      })
    },
    bookOnCallService (curComp) {
      if (curComp.comp_status === 'Out Of Scope') {
        curComp.comp_status = 'On-call Service Booked'
      } else {
        curComp.comp_status = 'Out Of Scope'
      }
      curComp.changed_by = config.USER_ID
      this.beingSaved = true
      this.axios.post(config.API_URL + '/comp/oncall', curComp)
      .then(response => {
        if (curComp.comp_status !== 'Out Of Scope') {
          this.msg('On-call service is booked, a representative will get in touch with you shortly')
        } else {
          this.msg('Booking has been cancelled')
        }
      })
      this.beingSaved = true
    },
    loadRateCard () {
      this.axios.get(config.API_URL + '/getOnCallRateCard/')
      .then(response => {
        this.rateCard = response.data
      })
    },
    getEmptyFilter () {
      var filter = {
        from_dt: null,
        to_dt: null,
        unit_id: null,
        created_user_pair_list: [],
        assigned_user_pair_list: [],
        comp_cat_list: [],
        comp_type_list: [],
        severity_list: [],
        comp_status_list: [],
        comp_id: null
      }
      return filter
    },
    applyFilter () {
      if (this.filterList[this.tab].from_dt > this.filterList[this.tab].to_dt) {
        this.msg('to date should be greater than from date')
      } else {
        if (!this.filterList[this.tab].from_dt && this.filterList[this.tab].to_dt) {
          this.filterList[this.tab].from_dt = this.filterList[this.tab].to_dt
        } else if (this.filterList[this.tab].from_dt && !this.filterList[this.tab].to_dt) {
          this.filterList[this.tab].to_dt = this.filterList[this.tab].from_dt
        }
        if (this.filterList[this.tab].comp_status_list.length || this.filterList[this.tab].severity_list.length || this.filterList[this.tab].comp_type_list.length || this.filterList[this.tab].comp_cat_list.length || this.filterList[this.tab].created_user_pair_list.length || this.filterList[this.tab].assigned_user_pair_list.length || this.filterList[this.tab].unit_id || this.filterList[this.tab].from_dt || this.filterList[this.tab].to_dt || this.filterList[this.tab].comp_id) {
          this.enabledFilter[this.tab] = true
        }
        if (this.tab === 'tab-0') {
          this.loadIndStats('mine')
          this.loadComps('mine', true)
        } else if (this.tab === 'tab-1') {
          this.loadIndStats('all open')
          this.loadComps('all open', true)
        } else {
          this.loadIndStats('all closed')
          this.loadComps('all closed', true)
        }
        this.showFilter = false
        this.$forceUpdate()
      }
    },
    filterCompCatList (curList) {
      this.filterList[this.tab].comp_cat_id_list = this.filterList[this.tab].comp_cat_list.map(rec => rec.comp_cat_id)
      this.$forceUpdate()
    },
    clearFilter () {
      this.filterList[this.tab].from_dt = null
      this.filterList[this.tab].to_dt = null
      this.filterList[this.tab].created_user_pair_list = []
      this.filterList[this.tab].assigned_user_pair_list = []
      this.filterList[this.tab].unit_id = null
      this.filterList[this.tab].comp_cat_list = []
      this.filterList[this.tab].comp_type_list = []
      this.filterList[this.tab].severity_list = []
      this.filterList[this.tab].comp_status_list = []
      this.filterList[this.tab].comp_id = null
      if (this.tab === 'tab-0') {
        this.loadIndStats('mine')
        this.loadComps('mine', true)
      } else if (this.tab === 'tab-1') {
        this.loadIndStats('all open')
        this.loadComps('all open', true)
      } else {
        this.loadIndStats('all closed')
        this.loadComps('all closed', true)
      }
      this.enabledFilter[this.tab] = false
      this.showFilter = false
    },
    loadCompRatings (curComp) {
      this.rComp = curComp
      var qry = {
        params: {
          comp_id: this.rComp.comp_id
        }
      }
      this.axios.get(config.API_URL + '/getCompRatingByCompId/', qry)
      .then(response => {
        if (response.data.length > 0) {
          Object.keys(response.data[0]).forEach(rec => {
            this.rComp[rec] = response.data[0][rec]
          })
        }
        this.showRating = true
      })
      .catch(err => {
        this.msg(err, true)
      })
      // allow or disallow user to rate
      this.rComp.is_related_user = curComp.user_can_rate && curComp.user_can_rate.split(',').map(rec => parseInt(rec)).indexOf(config.USER_ID) > -1
    },
    saveRatings (curComp, onlyOverall) {
      curComp.only_overall_updated = onlyOverall
      this.axios.post(config.API_URL + '/comp/ratings', curComp)
      .catch(err => {
        this.msg(err, true)
      })
    },
    cancelRating () {
      this.showRating = false
    },
    loadListOfPeopleAgreed (curComp) {
      var qry = {
        params: {
          comp_id: curComp.comp_id
        }
      }
      this.axios.get(config.API_URL + '/getListOfPeopleAgreed/', qry)
      .then(response => {
        this.totalAgreed = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadListOfPeopleCommentedComp (curComp) {
      var qry = {
        params: {
          comp_id: curComp.comp_id
        }
      }
      this.axios.get(config.API_URL + '/getListOfPeopleCommentedComp/', qry)
      .then(response => {
        this.totalComment = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadListOfPeoplePinnedComp (curComp) {
      var qry = {
        params: {
          comp_id: curComp.comp_id
        }
      }
      this.axios.get(config.API_URL + '/getListOfPeoplePinnedComp/', qry)
      .then(response => {
        this.totalPinned = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Complaints.vue?68d72066